var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHandler = function SvgHandler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "handler_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".handler_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "handler_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "handler_svg__st1",
    d: "M21.06 10.73c0-.01.01-.02.01-.03V5.85a1.16 1.16 0 0 0-2.32 0v3.63h-1.31V3.43a1.16 1.16 0 0 0-2.32 0v6.05h-1.31V1.16a1.16 1.16 0 0 0-2.32 0v8.32h-1.31V3.43a1.16 1.16 0 0 0-2.32 0v7.26c0 .02.01.03.01.05-.03.13-.05.26-.05.4v2.98L4.95 10.7c-.91-1.09-2.65.18-1.88 1.38l6.01 9.44a2 2 0 0 0 .99.8 6.597 6.597 0 0 0 4.4 1.67c3.67 0 6.65-2.98 6.65-6.65v-6.21c0-.14-.02-.27-.06-.4z"
  })));
};
export default SvgHandler;